module.exports = __webpack_public_path__ + "8c8a521583a295253188be1efed73d16.png";